import mapToDictionary from '@src/utils/dictionary'
import uuidv4 from 'uuid/v4'
import type { SyslogServerInfo } from '@src/endpoints/services/commonHdr.service'
import type { SystemLog } from '../models'

export const getIpAndPort = (endpoint: string) => {
  const array = (endpoint || '').split(':')
  const isValid = array.length > 1
  return {
    ip: isValid ? array[0] : '',
    port: isValid ? array[1] : ''
  }
}

export interface SysLogsDict {
  [id: string]: SystemLog
}

export const mapToDictSysLogs = (logs: SyslogServerInfo[]): SysLogsDict =>
  mapToDictionary({
    array: logs.map(x => ({ ...x, id: uuidv4() })),
    key: 'id',
    iterator: ({ id, endpoint, network, credentials }) => ({
      id,
      data: {
        ...getIpAndPort(endpoint),
        network,
        credentials
      },
      isVerify: false,
      isNew: false
    })
  })

export const newSL: SystemLog = {
  data: {
    ip: '',
    port: '514',
    network: null,
    credentials: null
  },
  isVerify: false,
  isNew: true
}

export const getNewSL = (): SysLogsDict => {
  const id = uuidv4()
  return { [id]: { ...newSL, id } }
}
